import { filter } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AccountModel } from '../../../models/account.model';
import { AccountsService } from '../../../services/accounts.service';
import { UserProfileService } from 'src/app/shared/services/user-profile.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { UserAccountFieldsComponent } from 'src/app/shared/components/user-account-fields/user-account-fields.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';


@UntilDestroy()
@Component({
    selector: 'app-accounts-general-info-tab',
    templateUrl: './accounts-general-info-tab.component.html',
    styleUrls: ['./accounts-general-info-tab.component.css'],
    standalone: true,
    imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    UserAccountFieldsComponent,
  ]
})
export class AccountsGeneralInfoTabComponent implements OnInit {
    public form: FormGroup;
    public selectedUser = this._usersService.currentUser;
    @Input() data: AccountModel;
    @Input() dialogRef: DialogRef;
    @Input() _saveAndClose: boolean;

    constructor(
        private _usersService: AccountsService,
        private _userProfileService: UserProfileService) {
    }

    ngOnInit(): void {
        this._userProfileService.onSaveSuccess$
            .pipe(
            filter(res => !!res),
            untilDestroyed(this)
            )
            .subscribe(() => {
            console.log('User updated successfully, closing dialog...');
            this.dialogRef.close('updated'); // semnal catre parinte
        });

    }

    save() {
        this.form.valid ? this.onSubmit() : this.form.markAllAsTouched();
    }

    saveAndExit() {
        if (this.form.valid) {
            this.onSubmit();
            this._saveAndClose = true;
        } else {
            this.form.markAllAsTouched();
        }
    }

    onSubmit() {
        const user = {
            ...this.form.value,
            id: this.data?.id,
            roles_ids: [this.form.value.roles_ids]
        };

        !this.form.controls.password.value && delete user.password;
        !this.form.controls.password_confirmation.value && delete user.password_confirmation;

        if (!this.data) {
            this._usersService.createAccount(user);
        } else {
            this.data.self_update ? this._userProfileService.updateUser(user) : this._usersService.updateAccount(user);
        }
    }

    updateUserForm(form: FormGroup) {
        this.form = form;
    }
}
